if (!customElements.get("sale-promotion-information")) {
  customElements.define(
    "sale-promotion-information",
    class SalePromotionInformation extends HTMLElement {
      constructor() {
        super();
        // this.html = this.querySelector(".discounted_price");
        this.discountedPriceHTML = this.querySelector(".discounted_price");
        this.price = this.getAttribute("data-price") / 100;
        this.compare_price = this.getAttribute("data-compare-price") / 100;
        this.normalPrice = this.querySelector("[data-normal-price]");
        this.hasTagPart = this.querySelector("[data-has-tag]");

        this.checker = setInterval(this.check.bind(this), 1000);
        if (this.getAttribute("data-option")) {
          this.option = JSON.parse(this.getAttribute("data-option"));
        }
        if (this.option?.startTime) {
          this.startTime = (new Date(this.option.startTime)).getTime();
        }
        if (this.option?.endTime) {
          this.endTime = (new Date(this.option.endTime)).getTime();
        }

        if (this.getAttribute("data-promotion-number").includes('%')) {
          this.discountMatch = this.getAttribute("data-promotion-number").slice(0, -1)
          this.discount = this.discountMatch ? this.discountMatch / 100 : 0;
          this.discountedPrice = (
            Number((this.price - this.price * this.discount).toFixed(2))
          ).toFixed(2);
        } else {
          this.discountMatch = this.getAttribute("data-promotion-number")
          this.discountedPrice = Number(
            this.price -
            Number(this.discountMatch ? this.discountMatch : 0).toFixed(2)
          ).toFixed(2);
        }
        this.saleInfo = this.querySelector("[data-sale-info]");
        this.newSaleInfo = this.querySelector("[data-new-sale-info]");
        this.productCardGrid = this.closest(".product-card-grid");
        this.finalDiscount = parseInt(
          ((this.compare_price - this.discountedPrice) * 100) /
          this.compare_price
        );
      }
      check() {
        let now = (new Date()).getTime();
        // 判定时间
        if (now > this.endTime || now < this.startTime) {
          this.hasTagPart?.classList.add("hidden");
          this.normalPrice?.classList.remove("hidden");
          this.productCardGrid
            ?.querySelector(".custom-product-card-sale-tag")
            ?.classList.add("hidden");
          this.closest(".custom-product-card-down")
            ?.querySelector(".custom-product-card-sale-tag")
            ?.classList.add("hidden");
          if (now > this.endTime) {
            clearInterval(this.checker);
          }
        } else {
          this.hasTagPart?.classList.remove("hidden");
          this.normalPrice?.classList.add("hidden");
          this.productCardGrid
            ?.querySelector(".custom-product-card-sale-tag")
            ?.classList.remove("hidden");
          this.closest(".custom-product-card-down")
            ?.querySelector(".custom-product-card-sale-tag")
            ?.classList.remove("hidden");
        }
      }
      connectedCallback() {
        let now = (new Date()).getTime();
        if (now < this.startTime || now > this.endTime) {
          // 判定时间
          this.hasTagPart?.classList.add("hidden");
          this.normalPrice?.classList.remove("hidden");
          this.productCardGrid
            ?.querySelector(".custom-product-card-sale-tag")
            ?.classList.add("hidden");

          this.closest(".custom-product-card-down")
            ?.querySelector(".custom-product-card-sale-tag")
            ?.classList.add("hidden");
        }
        if (this.finalDiscount > 0) {
          if (
            this.closest(".custom-product-card-down")?.querySelector(
              ".custom-product-card-sale-tag"
            )
          ) {
            this.closest(".custom-product-card-down").querySelector(
              ".custom-product-card-sale-tag"
            ).innerText = this.finalDiscount + "%" + " OFF";
            if (now >= this.startTime && now <= this.endTime) {
              // 判定时间
              this.closest(".custom-product-card-down").querySelector(".custom-product-card-sale-tag").classList.remove("hidden");
            }
          }
          if (this.productCardGrid) {
            this.productCardGrid.querySelector(
              ".custom-product-card-sale-tag"
            ).innerText = this.finalDiscount + "%" + " OFF";
            if (now >= this.startTime && now <= this.endTime) {
              // 判定时间
              this.productCardGrid
                .querySelector(".custom-product-card-sale-tag")
                .classList.remove("hidden");
            }
            // this.productCardGrid.querySelector(".product-discount-tag6")
          } else {

          }
        }
        if (this.discountedPrice >= 0) {
          // this.discountedPriceHTML.innerText = "$" + this.discountedPrice;
        }
        if (!this.newSaleInfo && this.saleInfo) {
          const copyBtn = this.querySelector('.copy');
          const code = this.saleInfo.getAttribute('data-code');
          if (copyBtn && code) {
            // 交给 document 事件委托（discount-tag-js），避免重复绑定
            copyBtn.setAttribute('type', 'button');
          }
        }
      }
    }
  );
}
